import { Button, theme } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import TourEditContext from '../TourEditContext';

interface ModalMobileFooterProps {
  buttonText: string;
  onButtonClick: () => void;
}

const ModalMobileFooter: React.FC<ModalMobileFooterProps> = ({
  buttonText,
  onButtonClick,
}) => {
  const { modalFooterRef } = useContext(TourEditContext);
  return (
    <StyledContainer ref={modalFooterRef}>
      <StyledButton type="primary" onClick={onButtonClick}>
        {buttonText}
      </StyledButton>
    </StyledContainer>
  );
};

export default ModalMobileFooter;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: inset 0px 1px 0px #f0f0f0;
  padding: 1.9rem;
`;

const StyledButton = styled(Button)`
  color: white;
  font-weight: 400;
  background-color: ${theme.blue6};
  border-radius: 2px;
  width: 100%;
  height: 40px;
`;
